import { render } from "./user_note.vue?vue&type=template&id=573fc555"
import script from "./user_note.js?vue&type=script&lang=js"
export * from "./user_note.js?vue&type=script&lang=js"

import "./user_note.vue?vue&type=style&index=0&id=573fc555&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__